import { useMutation } from 'react-query';
import { deleteCV } from 'api/file';

export const useDeleteFileFromBucket = () => {
  return useMutation<string, Error, string>(async (fileLink) => {
    const { data } = await deleteCV(fileLink);
    return data;
  });
};
